module.exports = __webpack_public_path__ + "static/media/spreadsheet.062dd2f8.svg";